export enum RecruitmentHistoryType {
	STATUS_CHANGED = "STATUS_CHANGED",
	NEXT_ACTION_DATE_CHANGED = "NEXT_ACTION_DATE_CHANGED",
	CURRENT_ACTION_CHANGED = "CURRENT_ACTION_CHANGED",
	NEXT_ACTION_CHANGED = "NEXT_ACTION_CHANGED",
	RECRUITED = "RECRUITED",
	NOTE_CHANGED = "NOTE_CHANGED",
	MESSAGE_SENT = "MESSAGE_SENT",
	INTERVIEW_NOTES_UPDATED = "INTERVIEW_NOTES_UPDATED",
}
